import React from "react"
import _ from "lodash"
import { DirtyNote_s } from "components/notes/notes-styles"

const NotesDisplay = (props: {rowData: {}, field: string}) => {
  const noteDetail = _.get(props.rowData, props.field)

  return (
    <span>
      Notes
      { _.get(noteDetail, "notes") && <DirtyNote_s/> }
    </span>
  )
}

export default NotesDisplay
